// the OAuth2 consent screen's "all owners" checkbox hides the per-owner list while checked
export function initOAuth2OwnerScopeAll(el: HTMLInputElement) {
  const list = document.querySelector<HTMLElement>(el.getAttribute('data-target')!)!;
  el.addEventListener('change', () => {
    list.style.display = el.checked ? 'none' : 'block';
  });
}

export function initOAuth2SettingsDisableCheckbox() {
  for (const el of document.querySelectorAll<HTMLInputElement>('.disable-setting')) {
    el.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      const dataTarget = target.getAttribute('data-target')!;
      document.querySelector(dataTarget)!.classList.toggle('disabled', target.checked);
    });
  }
}
